import {
  ValidationRenderer,
  RenderInstruction,
  ValidateResult,
} from "aurelia-validation";

/**
 * A validation renderer that attaches validation messages to form elements,
 * using Bootstrap 4 classes.
 */
export class BootstrapFormRenderer implements ValidationRenderer {
  render(instruction: RenderInstruction): void {
    for (let { result, elements } of instruction.unrender) {
      for (let element of elements) {
        this.remove(element, result);
      }
    }

    for (let { result, elements } of instruction.render) {
      for (let element of elements) {
        console.log(element);
        this.add(element, result);
      }
    }
  }

  public add(element: Element, result: ValidateResult) {
    if (!element.parentNode) {
      return;
    }

    if (result.valid) {
      if (!element.classList.contains("is-invalid")) {
        //element.classList.add("is-valid");
      }
    } else {
      //element.classList.remove("is-valid");
      element.classList.add("is-invalid");

      const message = document.createElement("div");
      message.className = "invalid-feedback";
      message.textContent = result.message;
      message.id = `validation-message-${result.id}`;

      element.parentNode.insertBefore(message, element.nextSibling);
    }
  }

  public remove(element: Element, result: ValidateResult) {
    if (!element.parentElement) {
      return;
    }

    if (result.valid) {
      //if (element.classList.contains("is-valid")) {
      //  element.classList.remove("is-valid");
      //}
    } else {
      const message = element.parentElement.querySelector(
        `#validation-message-${result.id}`,
      );
      if (message) {
        element.parentElement.removeChild(message);

        element.classList.remove("is-invalid");
      }
    }
  }
}
